<div class="sign-in-page min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active" ><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Connexion</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            SE <span style="color : #BADFFF"> CONNECTER </span>
                        </h1>
                        <h6 class="description">
                            THE DOOR MAN propose des outils afin que les divers acteurs de l’immobilier puissent
                            interagir entre eux, visualisation des biens avec un espace personnalisé sécurisé.
                            <br>
                            Des clients contents, des Conseillers en immobilier partenaires de confiance… tout cela pour vendre
                            un bien immobilier en toute tranquillité, dans le délai souhaité et au meilleur prix
                            possible !
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="sign-in-bloc py-5">
        <div class="bloc-sign-in container">
            <div class="bg-white shadow rounded">
                <div class="row">
                    <div class="col-md-7 ">
                        <div class="form-left h-100 py-5 px-5">
                            <form #loginForm="ngForm" class="row g-4">
                                <div class="col-12">
                                    <div class="alert alert-danger" [hidden]="!showError" [innerHTML]="errorMessage">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label for="signin-email">E-MAIL<span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <div class="input-group-text"><i class="bi bi-person-fill"></i></div>
                                        <input id="signin-email" type="email" class="form-control" placeholder="Entrer votre e-mail"
                                            pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                                            [(ngModel)]="user.login" name="email" #email="ngModel">
                                    </div>
                                </div>

                                <div class="col-12">
                                    <label for="signin-password">MOT DE PASSE<span class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <div class="input-group-text"><i class="bi bi-lock-fill"></i></div>
                                        <input id="signin-password" type="password" name="password" [(ngModel)]="user.password"
                                            class="form-control" placeholder="Entrer votre mot de passe">
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-check">
                                        <input class="form-check-input" name="stayLogged" [(ngModel)]="user.stayLogged" type="checkbox" id="inlineFormCheck">
                                        <label class="form-check-label" for="inlineFormCheck">RESTER CONNECTÉ</label>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <a [routerLink]="['/mot-de-passe-oublie']" routerLinkActive="router-link-active"  class="float-end text-primary">Mot de passe oublié ?</a>
                                </div>

                                <div class="col-12">
                                    <button type="submit" (click)="userLogin(user, false, loginForm.invalid)"
                                        class="btn btn-primary px-4 float-end mt-4">
                                        <div *ngIf="isLoader" class="spinner-border text-light" role="status">
                                        </div>
                                        <span *ngIf="!isLoader"> Se connecter</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-5 ">
                        <div class="form-right h-100 bg-primary text-white text-start p-5">
                            En demandant à un Conseiller de créer votre compte <span class="blue-text"><strong>THE DOOR MAN</strong></span>, vous
                            bénéficiez de nombreux services :
                            <div class="clearfix float-content mt-2">
                                <ul>
                                    <li>Informations sauvegardées</li>
                                    <li>Réception des offres par mail</li>
                                    <li>Prise de rendez-vous pour un bien</li>
                                    <li>Enregistrement de vos recherches</li>
                                    <li>Enregistrement de vos biens favoris</li>
                                    <li>Abonnement à la newsletter</li>
                                    <li>Suivi personnalisé</li>
                                </ul>
                                <button [routerLink]="['/amis-tdm/liste']" type="submit" class="btn btn-outlined  px-4 float-end mt-4">
                                    Trouver mon Conseiller</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
